import { render, staticRenderFns } from "./DatesFilter.vue?vue&type=template&id=d5963f86&"
import script from "./DatesFilter.vue?vue&type=script&lang=js&"
export * from "./DatesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports